import { FacilityAndSpaceFeatures, LeaseAccountPaymentStatus, LeaseInterface } from "@swivl-mono/types";
import { useMemo } from "react";

import Pill, { PillSize, PillStyle, PillType } from "../Pill/Pill";
import "./DataCard.Lease.scss";

interface LeaseCardProps {
  lease: LeaseInterface;
}

interface PillsProps {
  names: string[];
}

const Pills: React.FC<PillsProps> = ({ names }) => {
  return names?.map((name) => {
    return <Pill key={name} type={PillType.DEFAULT} size={PillSize.SMALL} style={PillStyle.LIGHT} text={name}></Pill>;
  });
};

export function DataCardLease(props: LeaseCardProps) {
  const { lease } = props;

  const data = useMemo(() => {
    const unitNumber = lease?.unit?.number;
    const unitFeatures = lease?.unit?.features?.map((feature: FacilityAndSpaceFeatures) => feature.toString()) || [];
    const leaseAccessCode = lease?.accessCode || "";
    const leasePaymentStatus = lease?.paymentStatus || "";
    const daysPastDue = lease?.daysPastDue || "0";

    return {
      daysPastDue,
      unitNumber,
      unitFeatures,
      leaseAccessCode,
      leasePaymentStatus
    };
  }, [lease]);

  const leaseBalance = lease?.balance?.toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00";

  return (
    <div className="DataCardLease">
      <div className="flex items-center justify-between">
        {data?.unitNumber && <span className="font-semibold">{`Unit ${data?.unitNumber}`}</span>}
        {data?.leasePaymentStatus === LeaseAccountPaymentStatus.PAST_DUE && (
          <span className="font-semibold text-red-500 capitalize">{data?.leasePaymentStatus}</span>
        )}
      </div>

      <div className="CardHeaderBody">
        <div className="CardHeaderBodyColumn">
          <div className="CardHeaderBodyItem flex flex-wrap gap-1">
            <Pills names={data?.unitFeatures} />
          </div>
        </div>
      </div>
      <div className="CardBody">
        <div className="CardBodyColumn">
          <span>Access Code:</span>
          {data?.leaseAccessCode && <span className="font-semibold"> #{data.leaseAccessCode}</span>}
        </div>
        <div className="CardBodyColumn">
          <span>Account Balance:</span>
          {leaseBalance && <span className="font-semibold"> ${leaseBalance}</span>}
        </div>
        <div className="CardBodyColumn">
          <span>Days Past Due:</span>
          {data?.daysPastDue && <span className="font-semibold"> {data?.daysPastDue}</span>}
        </div>
      </div>
    </div>
  );
}
